module.exports = {
  RESIZE_DEBOUNCE_DELAY: 100,
  REQUEST_DEBOUNCE_DELAY: 30,
  TOOLTIP_HIDE_DELAY: 300,
};
